import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Import page components
import { 
  VeteransPage, 
  StorefrontHome, 
  ResumeLandingPage, 
  ResumeBuilder, 
  SuccessPage,
  PhoenixITHubPage,
  ScribeFlowStudioPage,
  AdminDashboard,
  ScrollToTop 
} from "@/components";
import ContactPage from "@/components/pages/ContactPage";
import AboutPage from "@/components/pages/AboutPage";
import TermsPage from "@/components/pages/TermsPage";
import PrivacyPage from "@/components/pages/PrivacyPage";

// ==================== RESUME MAIN COMPONENT ====================
const ResumePage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.content;
    document.title = "AiQ Phoenix Tech — Careers | An AiQuireS Tool";
    if (description) description.content = "Affordable resume and career-document tools from AiQuireS. Build professional-grade documents grounded in your real experience.";
    return () => {
      document.title = previousTitle;
      if (description && previousDescription !== undefined) description.content = previousDescription;
    };
  }, []);
  const [showBuilder, setShowBuilder] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState("complete");

  if (showBuilder) {
    return (
      <ResumeBuilder 
        selectedPackage={selectedPackage} 
        onBack={() => setShowBuilder(false)} 
      />
    );
  }

  return (
    <ResumeLandingPage 
      onGetStarted={() => setShowBuilder(true)}
      onSelectPackage={setSelectedPackage}
    />
  );
};

// ==================== MAIN APP ====================
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster 
        position="top-center" 
        richColors 
        toastOptions={{
          style: { background: 'hsl(var(--background))', border: '1px solid hsl(var(--border))' }
        }} 
      />
      <Routes>
        <Route path="/" element={<StorefrontHome />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/veterans" element={<VeteransPage />} />
        <Route path="/resume" element={<ResumePage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/phoenix-it-hub" element={<PhoenixITHubPage />} />
        <Route path="/scribe-flow-studio" element={<ScribeFlowStudioPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
